<script>
import EmployeeManagementToggleAll from './EmployeeManagementToggleAll.vue'
import AdministrationManagementTableAction from './AdministrationManagementTableAction.vue'
import EmployeeManagementStatusIcon from './EmployeeManagementStatusIcon.vue'
import  { getEmployeeTableHeaders }  from '@/components/table-headers/EmployeeTableHeaders.js'
import AdministratorToggle from '@/components/backoffice/organization/AdministratorToggle.vue'
import store from '@/store'

export default {
  components: {
    AdministratorToggle,
    ToggleAll: EmployeeManagementToggleAll,
    TableAction: AdministrationManagementTableAction,
    StatusIcon: EmployeeManagementStatusIcon
  },
  props: {
    employees: {
      type: Array,
      required: false
    }
  },
  data: vm => ({
    search: '',
    loading: false,
    toggleLoading: false,
    userSettingsToggle: { state: false, item: {} },
    hasInput: vm.$permissions.hasInput,
    selected: [],
    selectedItem: {},
    userInboxes: [],
    inboxes: [],
    headers: getEmployeeTableHeaders(vm),
    members: [],
    notification: {
      state: false,
      type: 'info',
      content: '',
      timeout: 3000
    }
  }),
  computed: {
    headersWithoutHiddenItems(){
      return this.headers.filter((header) => {
        return !header.isHidden
      })
    },
    accepted() {
      return status => status === this.$enums.InvitationStatus.Accepted
    },
    acceptedMember() {
      return this.members.filter(
        member => member.status === this.$enums.InvitationStatus.Accepted
      )
    },
    organizationAdminCount() {
      return this.members.filter(member => member.isAdmin).length
    },
    memberState() {
      return prop => {
        const acceptedMember = this.acceptedMember
        const filteredMember = this.filterMember(acceptedMember, prop)
        if (filteredMember.length === acceptedMember.length) {
          return true // All member locked
        } else {
          // null if some member locked, false if none member locked
          return filteredMember.length ? null : false
        }
      }
    },
  },
  watch: {
    employees: {
      handler: function(val) {
        this.members = val
      },
      deep: true
    },
    members: {
      handler: function() {
        if (this.hasInput) {
          this.getInboxesList()
        }
      },
      deep: true
    }
  },
  created() {
    if (this.$props.employees) {
      this.members = this.$props.employees
    } else {
      this.getInvitedPeople()
      if (this.hasInput) {
        this.getInboxesList()
      }
    }
  },
  methods: {
    filterMember(members, prop) {
      return members.filter(member => member[prop])
    },
    getInvitedPeople() {
      this.loading = true
      this.$organizationService
        .invitedPeople()
        .then(members => {
          this.members = members
          this.userInboxes = members?.map(m => {
            return { id: m.id, inboxes: m.inboxes }
          })
        })
        .catch((error) => {
          console.error('error getting invited people', error)
          this.$notify(this.$t('global.get.invited.people.error'), {type: 'error'})
        })
        .finally(() => {
          this.loading = false
        })
    },
    getInboxesList() {
      this.loading = true
      this.$inboxService
        .getInboxesList()
        .then(inboxes => {
          this.inboxes = inboxes.data
        })
        .catch((error) => {
          console.error('error getting inboxes list', error)
          this.$notify(this.$t('component.inbox.list.error'), {type: 'error'})
        })
        .finally(() => {
          this.loading = false
        })
    },
    addingInboxesToUser(inboxIds, user) {
      this.loading = true
      this.$inboxService
        .assignInboxesToUser(user.id, inboxIds)
        .then(() => {
          let item = this.userInboxes.find(u => u.id === user.id)
          item.inboxes = inboxIds.map(i => {
            return { inboxId: i, inboxname: this.inboxes.find(inbox => inbox.id === i).inboxname }
          })
        })
        .catch((error) => {
          console.error(error)
          this.$notify(this.$t('component.inbox.assign.to.user.error'), {type: 'error'})
        })
        .finally(() => {
          this.loading = false
          this.getInboxesList()
        })
    },
    async resendInvitation(user) {
      const organizationId = store.getters.selectedOrganization.OrganizationId || null
      await this.$organizationService
        .sendInvitation({
          organizationId: organizationId,
          email: user.email,
          envUrl: `${window.config.VUE_APP_BASE_URL}`
        })
        .then(() => {
          this.$notify(this.$t('global.resend.invitation.success'), {type: 'success'})
          this.getInvitedPeople()
        })
        .catch(() => {
          this.$notify(this.$t('global.resend.invitation.error'), {type: 'error'})
        })
    },
    async cancelInvitation(user) {
      await this.$organizationService
        .deleteInvitation(user.id)
        .then(() => {
          this.$notify(this.$t('global.cancel.invitation.success'), {type: 'success'})
          this.getInvitedPeople()
        })
        .catch(() => {
          this.$notify(this.$t('global.cancel.invitation.error'), {type: 'error'})
        })
    },
    async deleteUser(user) {
      await this.$organizationService
        .deleteUser(user.id)
        .then(() => {
          this.$notify(this.$t('global.delete.user.success'), {type: 'success'})
          this.getInvitedPeople()
        })
        .catch(() => {
          this.$notify(this.$t('global.delete.user.error'), {type: 'error'})
        })
    },
    async lockUserSettings(user) {
      await this.$userService
        .lockUserSettings({
          id: user.id,
          locked: user.userSettingsLocked
        })
        .then(() => {
          this.$notify(this.$t('global.save.settings.success'), {type: 'success'})
        })
        .catch(() => {
          this.$notify(this.$t('global.save.settings.error'), {type: 'error'})
        })
    },
    async handleChangeOrgaMergeEnabled(user) {
      await this.$userService
        .setOrgaMerge({
          id: user.id,
          enabled: user.orgaMergeEnabled
        })
        .then(() => {
          this.$notify(this.$t('global.save.settings.success'), {type: 'success'})
        })
        .catch(() => {
          this.$notify(this.$t('global.save.settings.error'), {type: 'error'})
        })
    },
    async handleToggle(event, apiName) {
      this.toggleLoading = true
      await this.$organizationService[apiName](event)
        .then(async () => {
          await this.getInvitedPeople()
          this.$notify(this.$t('global.save.settings.success'), {type: 'success'})
        })
        .catch(() => {
          this.$notify(this.$t('global.save.settings.error'), {type: 'error'})
        })
        .finally(() => {
          this.toggleLoading = false
        })
    },
    handleUserSettingsToggle(item) {
      this.userSettingsToggle.state = !this.userSettingsToggle.state
      this.userSettingsToggle.item = item
      this.$emit('onUserSettingsToggle', this.userSettingsToggle)
    },
    inboxesSanitizedForInboxSelect(item) {
      try {
        const user = this.userInboxes.find(u => u.id === item.id)
        if (user && user?.inboxes) {
          return user.inboxes.map(i => i.inboxId)
        }
      } catch (e) {
        console.error(e)
      }
    },
    inboxesSortedAlphabetically() {
      return [...this.inboxes].sort((a, b) => {
        if (a.inboxname ===
          this.$t('global.inbox')
          && b.inboxname !== this.$t('global.inbox')) return -1
        if (b.inboxname ===
          this.$t('global.inbox')
          && a.inboxname !== this.$t('global.inbox')) return 1
        if (a.inboxname && b.inboxname) {
          return a.inboxname.localeCompare(b.inboxname)
        }
        return 0
      })
    },
    customFilter(_, search, item) {
      if (!search) return true
      const normalizedSearch = search.toString().toLowerCase().trim().replace(/\s+/g, '')
      let combinedText = ''
      if (item.firstName) combinedText += item.firstName + ' '
      if (item.lastName) combinedText += item.lastName + ' '
      if (item.email) combinedText += item.email + ' '
      if (item.inboxes && Array.isArray(item.inboxes)) {
        combinedText += item.inboxes.map(inbox => inbox.inboxname).join(' ')
      }
      combinedText = combinedText.toLowerCase().trim().replace(/\s+/g, '')
      return combinedText.includes(normalizedSearch)
    }
  }
}
</script>
<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('global.search.label')"
          single-line
          hide-details>
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headersWithoutHiddenItems"
        :items="members"
        :custom-filter="customFilter"
        :search="search"
        :loading="loading"
        :header-props="{sortByText: $t('global.sort.by.text')}"
        :footer-props="{
          'items-per-page-text': $t('global.items.per.page.text'),
          'items-per-page-all-text': $t('global.items.per.page.all.text'),
          'page-text': $t('global.page.text'),
          'items-per-page-options': [25, 50, 100]
        }"
        item-key="Id"
        class="elevation-1"
        fixed-header
        calculate-widths>
        <template #[`header.isAdmin`]></template>
        <template #[`header.inboxes`]>
          <span v-if="hasInput">
            {{$t('global.inboxes')}}
          </span>
        </template>
        <template #[`header.userSettings`]>
          <v-icon>mdi-cog</v-icon>
        </template>
        <template #[`header.userSettingsLocked`]="{ header }">
          <ToggleAll
            v-if="acceptedMember.length"
            :header="{value:header.value,text:'', icon:'mdi-lock'}"
            :state="memberState(header.value)"
            :loading="toggleLoading"
            @onToggle="handleToggle($event, header.apiName)"/>
          <v-icon v-else>mdi-lock</v-icon>
        </template>
        <template #[`header.orgaMergeEnabled`]="{ header }">
          <ToggleAll
            v-if="acceptedMember.length"
            :header="{value:header.value,text:'',icon:'mdi-set-merge'}"
            :state="memberState(header.value)"
            :loading="toggleLoading"
            @onToggle="handleToggle($event, header.apiName)"/>
          <v-icon v-else>mdi-set-merge</v-icon>
        </template>
        <template #[`item.isAdmin`]="{ item }">
          <AdministratorToggle :user="item" @promote="item.isAdmin = !item.isAdmin" />
        </template>
        <template #[`item.status`]="{ item }">
          <StatusIcon :type="+item.status" />
        </template>
        <template
          #[`item.inboxes`]="{item}">
          <span v-if="hasInput" id="administration-user-inbox-select">
            <v-autocomplete
              :key="+userInboxes.length"
              style="max-width:250px;"
              :flat="false"
              multiple
              :label="('inboxes' in item && item.inboxes !== null) ? '' : $t('button.select')"
              chips
              hide-details
              density="compact"
              clearable
              :value="inboxesSanitizedForInboxSelect(item)"
              :items="inboxesSortedAlphabetically()"
              :item-text="inbox => inbox.inboxname"
              :no-data-text="$t('global.no.data.text')"
              :item-value="inbox => inbox.id"
              @input="inboxIds => addingInboxesToUser(inboxIds, item)">
            <template #selection="{ item: inboxItem, index }">
              <v-chip v-if="index < 2">
                <span>{{ inboxItem.inboxname }}</span>
              </v-chip>
              <span
                v-if="index === 2"
                class="text-grey text-caption align-self-center">
                  (+ {{ ('inboxes' in item && item.inboxes !== null) ? userInboxes.find(u => u.id === item.id).inboxes.length - 2 : ''
                }} {{$t('global.more')}})
                </span>
            </template>
          </v-autocomplete>
          </span>
        </template>
        <template #[`item.userSettingsLocked`]="{ item }">
          <div v-if="accepted(item.status) || item.isAdmin" :class="[$permissions.hasOutput ? 'd-flex justify-end' : 'd-none']">
            <v-simple-checkbox
              v-model="item.userSettingsLocked"
              @input="lockUserSettings(item)"/>
          </div>
        </template>
        <template #[`item.userSettings`]="{ item }">
          <div v-if="accepted(item.status) || item.isAdmin" :class="[$permissions.hasOutput ? 'd-flex justify-center mt-2' : 'd-none']">
            <v-badge
              :color="item.userSettingsLocked ? 'error' : 'success'"
              :icon="item.userSettingsLocked ? 'mdi-lock' : 'mdi-lock-open'"
              bordered
              overlap>
              <v-btn icon @click="handleUserSettingsToggle(item)">
                <v-icon color="primary">mdi-account-cog</v-icon>
              </v-btn>
            </v-badge>
          </div>
        </template>
        <template #[`item.orgaMergeEnabled`]="{ item }">
          <div v-if="accepted(item.status) || item.isAdmin" :class="[$permissions.hasOutput ? 'd-flex justify-end' : 'd-none']">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-simple-checkbox
                  v-model="item.orgaMergeEnabled"
                  color="primary"
                  v-on="on"
                  @input="handleChangeOrgaMergeEnabled(item)">
                </v-simple-checkbox>
              </template>
              <span>
                {{ $t('component.profile.administrationManagement.cross.employee') }}
              </span>
            </v-tooltip>
          </div>
        </template>
        <template #[`item.action`]="{ item }">
          <span v-if="item.status === $enums.InvitationStatus.Pending">
            <TableAction
              confirmation
              icon="mdi-email"
              @confirmed="resendInvitation(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.resend.invitation')">
                </span>
              </template>
               <template slot="tooltip">{{ $t('component.profile.administrationManagement.send.invitation') }}
               </template>
            </TableAction>
            <TableAction
              confirmation
              icon="mdi-close"
              color="error"
              @confirmed="cancelInvitation(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.delete.invitation')">
                </span>
              </template>
              <template slot="tooltip">{{ $t('component.profile.administrationManagement.cancel.invitation') }}</template>
            </TableAction>
          </span>
          <span v-if="item.status === $enums.InvitationStatus.Accepted">
            <TableAction
              confirmation
              icon="mdi-delete"
              color="error"
              :disabled-outer-button="item.isAdmin && organizationAdminCount <= 1"
              @confirmed="deleteUser(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.delete.user.info')">
                </span></template>
             <template slot="tooltip">
               {{ $t('component.profile.administrationManagement.delete.user') }}</template>
            </TableAction>
          </span>
          <span v-if="item.status === $enums.InvitationStatus.Rejected">
            <TableAction
              confirmation
              icon="mdi-close"
              color="error"
              @confirmed="cancelInvitation(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.remove.entry')">
                </span>
              </template>
              <template slot="tooltip">
              {{ $t('component.profile.administrationManagement.delete.entry') }}</template>
            </TableAction>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.v-chip.v-size--default {
  font-size: 12px;
}

#administration-user-inbox-select >>> .v-label.theme--light {
  font-size: 12px;
}
</style>
